module.exports = __webpack_public_path__ + "img/37.e72bf11b.png";